module.exports = __webpack_public_path__ + "img/7e4a7d3.jpg";